<template>
  <div>
    <div class="feedback">
      <transition name="fade" @enter="enterSuccess">
        <feedback-success v-if="isShowableSuccess" :message="successMessage" />
      </transition>
      <transition name="fade" @enter="enterError">
        <feedback-error v-if="isShowableError" :message="errorMessage" />
      </transition>
    </div>
    <div
      v-if="isDisplayableToggleTextLink"
      class="send-other-way-text-link__area"
      @click="toggleShowSendOtherWayArea"
    >
      <p
        class="text-link--bold send-other-way-text-link"
        :class="{
          'tl-chevron-up--bold--right': isShowSendOtherWayArea,
          'tl-chevron-down--bold--right': !isShowSendOtherWayArea
        }"
      >
        {{ textLinkText }}
      </p>
    </div>
    <div
      v-if="!isDisplayableToggleTextLink || isShowSendOtherWayArea"
      class="send-gift-area"
    >
      <div class="buttons-multi url-share-attention__area">
        <div class="btn-multi-block btn-multi-expand-block">
          <div
            class="btn-multi btn-multi-expand--active url-share-attention__header"
          >
            URLのお取り扱いについてのご注意
          </div>
          <div class="btn-multi-expand__contents">
            <div class="btn-multi-expand__explanation">
              <p>ギフトURLは知っていれば誰でもアクセス可能です。</p>
              <p>
                TwitterのリプライやLINEのグループトークなど、<strong>第三者がアクセスできる場所に意図せず投稿しないよう</strong>ご注意ください。
              </p>
            </div>
          </div>
        </div>
      </div>
      <p class="gift-url">
        {{ giftUrl }}
      </p>
      <div class="send-gift-main-button-area">
        <button
          class="btn copy-url-button"
          :class="{
            'btn--primary': isCopyButtonPrimary,
            'btn--secondary': !isCopyButtonPrimary
          }"
          @click="onCopy"
        >
          ギフトURLをコピーする
        </button>
        <button
          class="btn btn--line send-by-line-button"
          @click="onClickLineButton"
        >
          <span class="btn--line__text">LINEで贈る</span>
        </button>
      </div>
      <div class="send-gift-other-way__area">
        <p class="send-gift-other-way__title">
          SNS・メールアプリで贈る
        </p>
        <p class="send-gift-other-way__sub">
          ギフトURLをコピーして、アプリ内で相手を選んで贈りましょう
        </p>
        <div class="send-gift-other-way__button-area">
          <button
            class="btn-sns btn-sns--s btn-sns--tw"
            @click="onClickTwitterButton"
          />
          <button
            class="btn-sns btn-sns--s btn-sns--fb-m"
            @click="onClickFacebookButton"
          />
          <button
            class="btn-sns btn-sns--s btn-sns--email"
            @click="onClickMailButton"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FeedbackSuccess from '../../atoms/feedbacks/feedback-success'
import FeedbackError from '../../atoms/feedbacks/feedback-error'

export default {
  components: { FeedbackSuccess, FeedbackError },
  props: {
    giftUrl: {
      type: String,
      required: true
    },
    isDisplayableToggleTextLink: {
      type: Boolean,
      required: true
    },
    isCopyButtonPrimary: {
      type: Boolean,
      required: true
    },
    textLinkText: {
      type: String,
      required: false,
      default: '他の方法で贈る'
    }
  },
  data() {
    return {
      isShowableSuccess: false,
      successMessage: '',
      isShowableError: false,
      errorMessage: '',
      isShowSendOtherWayArea: false
    }
  },
  methods: {
    pushGiftSendingToDataLayer(sentVia) {
      dataLayer.push({
        event: 'gift_sending',
        sent_via: sentVia
      })
    },
    onCopy() {
      this.pushGiftSendingToDataLayer('copy')
      const urlEement = document.querySelector('.gift-url')
      document.getSelection().selectAllChildren(urlEement)
      const result = document.execCommand('copy')
      document.getSelection().empty()
      if (result) {
        this.successMessage = 'ギフトURLをコピーしました'
        this.isShowableSuccess = true
      }
      event.preventDefault()
    },
    enterSuccess() {
      setTimeout(() => {
        this.isShowableSuccess = false
      }, 3000)
    },
    enterError() {
      setTimeout(() => {
        this.isShowableError = false
      }, 3000)
    },
    onClickLineButton() {
      this.pushGiftSendingToDataLayer('line')
      const url = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
        this.giftUrl
      )}`
      this.openUrlInNewPage(url)
    },
    onClickTwitterButton() {
      this.pushGiftSendingToDataLayer('twitter')
      this.openUrlInNewPage('https://twitter.com/messages')
    },
    onClickFacebookButton() {
      this.pushGiftSendingToDataLayer('messenger')
      this.openUrlInNewPage('https://www.facebook.com/messages/new')
    },
    openUrlInNewPage(url) {
      window.open(url, '_blank')
    },
    onClickMailButton() {
      this.pushGiftSendingToDataLayer('mail')
      // mailtoはwindow.openで開くとtoが更新されないなどの事象が発生するのでwindow.location.hrefを使用する
      window.location.href = `mailto:?subject=[giftee]ギフトを贈ります！&body=${encodeURIComponent(
        this.giftUrl
      )}`
    },
    onClickBackToTop() {
      window.location.href = '/'
    },
    onClickBackWishList(path) {
      window.location.href = path
    },
    toggleShowSendOtherWayArea() {
      this.isShowSendOtherWayArea = !this.isShowSendOtherWayArea
    }
  }
}
</script>
<style lang="scss" scoped>
.url-share-attention {
  &__area {
    max-width: 343px;
    margin: 0 auto 32px auto;
  }

  &__header {
    text-align: center;
    font-weight: bold;
    line-height: 1.6;
    color: $danger;
    cursor: default;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
